import React, { Component } from "react";
import "../../App.css";
import { getMutualFundHoldings } from "../../Api/Http";
import mutualFundHoldingsConfig from "../../config/mutualFundHoldings.json";
import defaultConfig from "../../config/default.json";
import { sort } from "../../Utils/utils";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const toNumber = value => (value === null || value === undefined ? null : parseFloat(value, 10));

const NUMBER_COLUMNS = ["last_price", "bullPrice", "bearPrice", "minInvestment"];

// Distance of bearPrice below NAV, same formula as Triggers' Percent column.
const getPercent = ({ lastPrice, bearPrice }) =>
    lastPrice && bearPrice ? parseFloat((((lastPrice - bearPrice) / lastPrice) * 100).toFixed(2), 10) : null;

class MutualFundHoldings extends Component {
    async componentDidMount() {
        const mapMutualFundHolding = value => {
            const resp = {};
            for (const key of Object.keys(mutualFundHoldingsConfig.page.columns)) {
                resp[key] = NUMBER_COLUMNS.includes(key) ? toNumber(value[key]) : value[key];
            }
            resp.percent = getPercent({ lastPrice: resp.last_price, bearPrice: resp.bearPrice });
            resp.data = value;
            return resp;
        };

        const getMappedMutualFundHoldings = async () => {
            const getMutualFundHoldingsResp = await getMutualFundHoldings();
            const resp = getMutualFundHoldingsResp.map(mapMutualFundHolding);
            this.setState({ getMappedMutualFundHoldingsResp: resp });
            this.setState({ mutualFundHoldingsCount: resp.length });
            return resp;
        };

        let getMappedMutualFundHoldingsResp = await getMappedMutualFundHoldings();

        const ordering = async ({ key, type }) => {
            if (type === defaultConfig.order.type.ascending) {
                this.state.visibility[key][defaultConfig.order.type.descending] = true;
                getMappedMutualFundHoldingsResp = sort({
                    data: this.state.getMappedMutualFundHoldingsResp,
                    key,
                    type,
                });
            }
            if (type === defaultConfig.order.type.descending) {
                this.state.visibility[key][defaultConfig.order.type.ascending] = true;
                getMappedMutualFundHoldingsResp = sort({
                    data: this.state.getMappedMutualFundHoldingsResp,
                    key,
                    type,
                });
            }
            this.state.visibility[key][type] = !this.state.visibility[key][type];
            this.setState({ getMappedMutualFundHoldingsResp: getMappedMutualFundHoldingsResp });
            this.setState({ visibility: this.state.visibility });
        };

        const setDefaultVisibilityOfColumns = () => {
            const obj = {};
            for (const iterator of Object.keys(mutualFundHoldingsConfig.page.columns)) {
                if (!obj[iterator]) {
                    obj[iterator] = {};
                }
                for (const orderIterator of Object.keys(defaultConfig.order.type)) {
                    if (defaultConfig.order.type.ascending === orderIterator) {
                        obj[iterator][orderIterator] = true;
                    } else {
                        obj[iterator][orderIterator] = false;
                    }
                }
            }
            return obj;
        };

        this.setState({ order: ordering });
        this.setState({ visibility: setDefaultVisibilityOfColumns() });
    }

    render() {
        let getMappedMutualFundHoldingsResp;
        if (this.state && this.state.getMappedMutualFundHoldingsResp) {
            //headers
            getMappedMutualFundHoldingsResp = [
                <div>
                    <tr>
                        {Object.keys(mutualFundHoldingsConfig.page.columns).map(value => (
                            <th className="triggers-table-columns-heading">
                                {mutualFundHoldingsConfig.page.columns[value].name}
                                {this.state.visibility &&
                                    this.state.visibility[value] &&
                                    this.state.visibility[value]["ascending"] && (
                                        <button
                                            onClick={() =>
                                                this.state.order({
                                                    key: value,
                                                    type: defaultConfig.order.type.ascending,
                                                })
                                            }
                                        >
                                            &#9650;
                                        </button>
                                    )}
                                {this.state.visibility &&
                                    this.state.visibility[value] &&
                                    this.state.visibility[value]["descending"] && (
                                        <button
                                            onClick={() =>
                                                this.state.order({
                                                    key: value,
                                                    type: defaultConfig.order.type.descending,
                                                })
                                            }
                                        >
                                            &#9660;
                                        </button>
                                    )}
                            </th>
                        ))}
                    </tr>
                </div>,
            ];
            //data
            getMappedMutualFundHoldingsResp.push(
                ...this.state.getMappedMutualFundHoldingsResp.map(value => (
                    <div id={value.fund}>
                        <tr>
                            {Object.keys(mutualFundHoldingsConfig.page.columns).map(key => (
                                <td className="triggers-table-rows" key={value.fund + "_" + key}>
                                    {value[key] !== null && value[key] !== undefined
                                        ? `${value[key]}${key === "percent" ? "%" : ""}`
                                        : "-"}
                                </td>
                            ))}
                        </tr>
                    </div>
                )),
            );
        }
        return (
            <div>
                <div>
                    <header className="header-with-tagline">
                        <h1>Mutual Funds ({(this.state && this.state.mutualFundHoldingsCount) || 0})</h1>
                    </header>
                </div>
                <div>
                    <header className="triggers-table">
                        <table>{getMappedMutualFundHoldingsResp}</table>
                    </header>
                </div>
                <ToastContainer />
            </div>
        );
    }
}

export default MutualFundHoldings;
